 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TITLE_PAGE from '@/components/title_page'
 import CHAP149101 from '@/components/chap149101'
 import CHAP149091 from '@/components/chap149091'
 import CHAP149088 from '@/components/chap149088'
 import CHAP149092 from '@/components/chap149092'
 import CHAP149102 from '@/components/chap149102'
 import CHAP149103 from '@/components/chap149103'
 import CHAP149104 from '@/components/chap149104'
 import CHAP149098 from '@/components/chap149098'
 import CHAP149084 from '@/components/chap149084'
 import CHAP149099 from '@/components/chap149099'
 import CHAP149105 from '@/components/chap149105'
 import CHAP149094 from '@/components/chap149094'
 import CHAP149097 from '@/components/chap149097'
 import CHAP149090 from '@/components/chap149090'
 import CHAP149086 from '@/components/chap149086'
 import CHAP149085 from '@/components/chap149085'
 import CHAP149100 from '@/components/chap149100'
 import CHAP149087 from '@/components/chap149087'
 import CHAP149095 from '@/components/chap149095'
 import CHAP149096 from '@/components/chap149096'
 import CHAP149106 from '@/components/chap149106'
 import CREDITS from '@/components/credits'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/title_page",
 			"name" : "title_page",
 			"component" : TITLE_PAGE
 		},
 		{
 			"path" : "/chap149101",
 			"name" : "chap149101",
 			"component" : CHAP149101
 		},
 		{
 			"path" : "/chap149091",
 			"name" : "chap149091",
 			"component" : CHAP149091
 		},
 		{
 			"path" : "/chap149088",
 			"name" : "chap149088",
 			"component" : CHAP149088
 		},
 		{
 			"path" : "/chap149092",
 			"name" : "chap149092",
 			"component" : CHAP149092
 		},
 		{
 			"path" : "/chap149102",
 			"name" : "chap149102",
 			"component" : CHAP149102
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js